import React, { useState } from "react";
import { SelectInput, useRecordContext, useNotify, useRefresh, TextInput } from "react-admin";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import IconButton from "@mui/material/IconButton";
import { TransactionStatusChoices } from "utils/choices";
import { PaymentStatuses } from "utils/constants";
import FormModal from "server/components/Modals/FormModal";
import { paymentRequests } from "api/paymentApi";
import dataProvider from "server/dataProvider";

const ChangeStatusButton = props => {
  const record = useRecordContext(props);
  const refresh = useRefresh();
  const notify = useNotify();

  const [selectedStatus, setSelectedStatus] = useState(record?.status || null);
  const [noPaidComment, setNoPaidComment] = useState(null);

  const handleStatusChange = event => {
    setSelectedStatus(event.target.value);
  };

  const handleConfirm = async () => {
    await dataProvider.customRequest(
      paymentRequests.changeBankTransferStatus(record?.id),
      {
        status: selectedStatus,
        comment: selectedStatus === PaymentStatuses.NotPaid ? noPaidComment : null,
      },
      "PUT",
    );

    notify("Статуса е променен успешно!", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Промяна на статус"
      onConfirm={handleConfirm}
      triggerButton={
        <IconButton color="primary">
          <SwapHorizontalCircleIcon />
        </IconButton>
      }
    >
      <SelectInput
        source="status"
        label="Статус на транзакция"
        defaultValue={selectedStatus}
        choices={TransactionStatusChoices}
        emptyText={false}
        onChange={handleStatusChange}
      />
      {selectedStatus === PaymentStatuses.NotPaid && (
        <TextInput
          label="Коментар"
          source="comment"
          value={noPaidComment}
          onChange={e => {
            setNoPaidComment(e.target.value);
          }}
          multiline
          resettable
        />
      )}
    </FormModal>
  );
};

export default ChangeStatusButton;
